import { createFileRoute } from '@tanstack/react-router'
import SecurityPage from '@/pages/security'
import { buildHead } from '@/shared/seo/seo-config'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/$lang/security')({
  beforeLoad: ({ params }) =>
    redirectIfPublicPageHidden('security', params.lang),
  head: ({ params }) => buildHead('security', params.lang),
  component: SecurityPage,
  staticData: { layout: 'public' },
})
